import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BillingModal = ({ isOpen, onClose, cartItems, cashiers, waiter, tableNumber, transactionNumber, apiUrl, handleBillingComplete }) => {
  const [pin, setPin] = useState('');
  const [selectedCashier, setSelectedCashier] = useState('');
  const [isPinValid, setIsPinValid] = useState(false);
  const [transactionType, setTransactionType] = useState('cash');
  const [seniorDiscount, setSeniorDiscount] = useState(false);
  const [seniorName, setSeniorName] = useState('');
  const [seniorId, setSeniorId] = useState('');
  const [seniorPax, setSeniorPax] = useState(0); // Number of seniors
  const [pax, setPax] = useState(1);
  const [promoDiscount, setPromoDiscount] = useState(0);
  const [VAT, setVAT] = useState(0);
  const [remarks, setRemarks] = useState('');
  const [amountPaid, setAmountPaid] = useState(0);
  const [change, setChange] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const [totalDiscountableAmount, setTotalDiscountableAmount] = useState(0);


  const [selectedDiscountItems, setSelectedDiscountItems] = useState([]);


  // Calculate total amount based on cart items
  useEffect(() => {
    const calculatedTotal = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

    //const calculatedTotal = cartItems.reduce((acc, item) => acc + item.price, 0);
    setTotalAmount(calculatedTotal);
  }, [cartItems]);

  // Validate Cashier PIN
  const verifyCashierPin = async () => {
    try {
      const data = { cashier: selectedCashier, cashierPin: pin };
      const response = await axios.post(`${apiUrl}/api/users/verifyCashierPin`, data);
      if (response.status === 200) {
        setIsPinValid(true);
        alert('PIN verified successfully');
      } else {
        setIsPinValid(false);
        alert('Invalid PIN. Please try again.');
      }
    } catch (error) {
      console.error('Error verifying PIN:', error);
      alert('Error verifying PIN. Please try again.');
    }
  };

  // Calculate discounts based on senior, promo, etc.
  const handleCalculateDiscounts = () => {
    let discount = 0;
  
    if (seniorPax > pax) {
      alert("Number of seniors cannot exceed the total number of customers.");
      return;
    }
  
    // Calculate VAT for total amount before discount
    setVAT(totalAmount * 0.12);
  
    if (seniorDiscount && seniorPax > 0) {
      // Senior Discount Calculation
      let totalDiscountableAmount = 0;
      let totalDiscountableVAT = 0;
      let totalAmtDisc = 0;
  
      // Calculate discountable amount based on selected items
      cartItems.forEach(item => {
        if (selectedDiscountItems.includes(item._id)) {
          const itemAmount = (item.price * item.quantity);
          const itemAmountWithoutVAT = itemAmount / 1.12; // Exclude VAT from item price
  
          const itemSeniorDiscount = itemAmountWithoutVAT * 0.20; // 20% senior discount
          const itemSeniorVAT = itemAmountWithoutVAT * 0.12; // VAT portion of the item
  
          console.log('itemAmount',itemAmount);
          totalAmtDisc += itemAmount;
          totalDiscountableAmount += itemSeniorDiscount;
          totalDiscountableVAT += itemSeniorVAT;
        }
      });

  
      // Calculate senior discount value
      const seniorDiscountValue = totalDiscountableAmount * (seniorPax / pax); // Apply per head discount for seniors
      const seniorVAT = totalDiscountableVAT * (seniorPax / pax); // VAT exclusion for seniors
      setTotalDiscountableAmount(totalAmtDisc); 
      setVAT(seniorVAT); // Set VAT based on the discountable items
      console.log('totalDiscountableAmount',totalAmtDisc);
      console.log('seniorVAT', seniorVAT);
      console.log('seniorDiscountValue', seniorDiscountValue);
  
      discount = seniorDiscountValue + seniorVAT; // Add both discount and VAT removal
    }
  
    console.log('discount', discount);
    setPromoDiscount(discount);
    // discount += promoDiscount; 

  
    console.log(totalAmount - promoDiscount); // Adjust for promotional discount
    return totalAmount - discount; // Adjust total amount based on discounts
  };
  

  // Handle payment process
  const handlePayment = () => {


    const finalAmount = handleCalculateDiscounts();
    const calculatedChange = amountPaid - finalAmount;

    if (transactionType === "cash") {
      if (amountPaid <= 0) {
        alert("Please enter a valid payment amount.");
        return;
      }
    
      if (calculatedChange < 0) {
        alert("The amount paid is insufficient.");
        return;
      }
    setChange(calculatedChange);

    
    } else {
      setAmountPaid(totalAmount);
      setChange(0);
    }
   
    console.log('totalAmount',totalAmount);

    // Proceed to print receipt or other checkout processes
    handlePrintBilling(finalAmount, calculatedChange);
  };

  const handleComputeChange = () => {
    const finalAmount = handleCalculateDiscounts();
    const calculatedChange = amountPaid - finalAmount;
    if (calculatedChange < 0) {
      return;
    }
    setChange(calculatedChange);
  }

  const toggleDiscountItem = (itemId) => {
    if (selectedDiscountItems.includes(itemId)) {
      setSelectedDiscountItems(selectedDiscountItems.filter(id => id !== itemId));
    } else {
      setSelectedDiscountItems([...selectedDiscountItems, itemId]);
    }

    const totalDiscount = calculateTotalWithDiscount;
    setTotalDiscountableAmount(totalDiscount);
    console.log('totalDiscount',totalDiscount);
  };

  const calculateTotalWithDiscount = () => {
    let total = 0;

    // Calculate discountable amount based on selected items
    cartItems.forEach(item => {
      if (selectedDiscountItems.includes(item._id)) {

        total += item.price * item.quantity;
      }
    });

   
    return total;
  };

  const handlePrintBilling = async (finalAmount, calculatedChange) => {
    // Prepare cartItems with quantity, name, price
    const formattedCartItems = cartItems.map(item => ({
        quantity: item.quantity, // Assuming item has a quantity property
        name: item.name,         // Assuming item has a name property
        price: item.price,       // Assuming item has a price property
    }));

    const billingData = {
        pin,
        transactionType,
        cartItems: formattedCartItems, // Use the formatted items
        waiter: waiter,
        cashier: selectedCashier,
        tableNumber,
        transactionNumber,
        seniorDiscount: seniorDiscount ? { seniorName, seniorId } : null,
        pax,
        VAT: VAT,
        promoDiscount,
        remarks,
        amountPaid,
        change: calculatedChange,
        totalDiscountableAmount,
        totalAmount: finalAmount,
        discount: promoDiscount || 0, // Include the discount if applicable
    };

    try {
        const response = await axios.post(`${apiUrl}/api/print-invoice`, billingData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        console.log('Invoice response:', response.data);


        // Call the function to update the order after successful billing
        await handleBillingComplete();

        //clear fields if success
        setPin('');
        setSelectedCashier('');
        setIsPinValid(false);
        setTransactionType('cash');
        setSeniorDiscount(false);
        setSeniorName('');
        setSeniorId('');
        setPax(1);
        setAmountPaid(0);
        setRemarks('');
        setChange(0);
        setTotalAmount(0);


        // Close modal after printing
        onClose();
    } catch (error) {
        console.error('Error printing billing:', error.response ? error.response.data : error.message);
        alert('Failed to print billing. Please try again.');
    }
};

 // Handle payment process
 const handlePrintInitialBillingStatement = () => {
  const finalAmount = handleCalculateDiscounts();
  const calculatedChange = amountPaid - finalAmount;
  
  if (calculatedChange > 0) {
  setChange(calculatedChange);
  }

  // Proceed to print receipt or other checkout processes
  handlePrintBillingStatement(finalAmount, calculatedChange);
};


const handlePrintBillingStatement = async (finalAmount, calculatedChange) => {
  // Prepare cartItems with quantity, name, price
  const formattedCartItems = cartItems.map(item => ({
      quantity: item.quantity, // Assuming item has a quantity property
      name: item.name,         // Assuming item has a name property
      price: item.price,       // Assuming item has a price property
  }));

  const billingData = {
    pin,
    transactionType,
    cartItems: formattedCartItems, // Use the formatted items
    waiter: waiter,
    cashier: selectedCashier,
    tableNumber,
    transactionNumber,
    seniorDiscount: seniorDiscount ? { seniorName, seniorId } : null,
    pax,
    VAT: VAT,
    promoDiscount,
    remarks,
    amountPaid,
    change: calculatedChange,
    totalDiscountableAmount,
    totalAmount: finalAmount,
    discount: promoDiscount || 0, // Include the discount if applicable
  };

  try {
      const response = await axios.post(`${apiUrl}/api/print-billing`, billingData, {
          headers: {
              'Content-Type': 'application/json',
          },
      });

      console.log('Billing response:', response.data);


      // Call the function to update the order after successful billing
      //await handleBillingComplete();

      //clear fields if success
     
        //clear fields if success
        setPin('');
        setSelectedCashier('');
        setIsPinValid(false);
        setTransactionType('cash');
        setSeniorDiscount(false);
        setSeniorName('');
        setSeniorId('');
        setPax(1);

      // Close modal after printing
      onClose();
  } catch (error) {
      console.error('Error printing billing:', error.response ? error.response.data : error.message);
      alert('Failed to print billing. Please try again.');
  }
};





  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-1/2 flex mt-4">
        {/* Left Side: Order Details */}
        <div className="w-1/2 pr-4 flex flex-col justify-start">

        <h2 className="text-lg font-semibold mb-4">Billing Statement</h2>
          {/* Display Table Number and Transaction Number */}
          <div className="mb-4">
            <label>Table Number: {tableNumber}</label>
          </div>
          <div className="mb-4">
            <label>Transaction Number: {transactionNumber}</label>
          </div>
          <div className="mb-4">
            <label>Waiter: {waiter}</label>
          </div>
          <h2 className="text-lg font-semibold mb-4">Order Details</h2>
          <ul className="space-y-2 text-slate-600 flex justify-between">
              <li className='text-left'>Qty</li>
              <li className='text-left text-wrap w-1/2'>Product Name</li>
              <li className='text-right'>Amount</li>
              <li >Disc.</li>

          </ul>
          <hr/>
          <ul className="space-y-2 mb-10">
          {cartItems.map((item, index) => (
            <li key={item._id || index} className="flex justify-between mb-4">
                <span className='text-right'>{item.quantity}</span> 
                <span className='text-left text-wrap w-1/2'>{item.name}</span> 
                <span className='text-right'>{item.price.toFixed(2)}</span> 
                <input
                  type="checkbox"
                  checked={selectedDiscountItems.includes(item._id)} // Ensure _id is used here as well
                  onChange={() => toggleDiscountItem(item._id)} 
                  disabled={!seniorDiscount}
                  className="mr-2"
                />
            </li>
          ))}
          </ul>
          <hr/>
          <ul className="space-y-2 mb-4">
            <li className="flex justify-between font-bold">
                <span>Total Amount:</span>
                <span>{totalAmount }</span>
            </li>
            <li className="flex justify-between font-bold">
                <span>Total Amt for Disc:</span>
                <span>{totalDiscountableAmount.toFixed(2) }</span>
            </li>
            <li className="flex justify-between font-bold">
                <span>Discount:</span>
                {promoDiscount.toFixed(2)}
            </li>
            <li className="flex justify-between font-bold">
                <span>Total Amount Due:</span>
                <span>{(totalAmount - promoDiscount).toFixed(2)}</span>
            </li>
            <li className="flex justify-between font-bold">
                <span>Change:</span>
                <span>{change.toFixed(2)}</span>
            </li>
          </ul>
          
          <button
                onClick={handlePrintInitialBillingStatement}
                className={`font-medium mt-4 text-black-500 shadow-md   focus:outline-none focus:ring-2 focus:ring-yellow focus:ring-offset-2 ${isPinValid ? 'bg-teal-500 text-slate-50 hover:bg-blue-700' : 'bg-slate-50 text-slate-600 hover:bg-gray-100'} px-4 py-2 rounded w-full mr-5`}
                disabled={!isPinValid} // Disable until PIN is valid
            >
            PRINT BILLING STATEMENT
          </button>

          <button
                onClick={handlePayment}
                className={`font-medium mt-4 text-black-500 shadow-md  focus:outline-none focus:ring-2 focus:ring-yellow focus:ring-offset-2 ${isPinValid ? 'bg-teal-500 text-slate-50 hover:bg-blue-700' : 'bg-slate-50 text-slate-600 hover:bg-gray-100'} px-4 py-2 rounded w-full mr-5`}
                disabled={!isPinValid} // Disable until PIN is valid
            >
            PROCESS PAYMENT
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white font-medium text-black-500 shadow-md  focus:outline-none focus:ring-2 focus:ring-yellow focus:ring-offset-2 px-4 py-2 rounded w-full mr-5 mt-5"
          >
            Close
          </button>
        </div>

        {/* Right Side: Billing Fields */}
        <div className="w-1/2">
          <h2 className="text-lg font-semibold mb-4">Payment Details</h2>

          {/* Cashier Selection Dropdown */}
          <select
            className="border border-gray-300 rounded p-2 mb-4 w-full"
            value={selectedCashier}
            onChange={(e) => setSelectedCashier(e.target.value)}
          >
            <option value="">Select Cashier</option>
            {cashiers.map((cashier) => (
              <option key={cashier.id} value={cashier.username}>{cashier.name}</option>
            ))}
          </select>

          

          {/* Cashier PIN input */}
          <input
            type="password"
            placeholder="Enter Cashier's PIN"
            className="border border-gray-300 rounded p-2 mb-4 w-full"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            onBlur={verifyCashierPin}
          />

          <label className="text-xs">Transaction Type</label>
          {/* Transaction Type Selection */}
          <select
            className="border border-gray-300 rounded p-2 mb-4 w-full"
            value={transactionType}
            onChange={(e) => setTransactionType(e.target.value)}
            disabled={!isPinValid} // Disable until PIN is verified
          >
            <option value="">Select Transaction Type</option>
            <option value="cash">Cash</option>
            <option value="credit">Credit Card</option>
            <option value="charge">Charge</option>
            <option value="free">Free of Charge</option>
          </select>

          {/* Senior Citizen Discount Section */}
          <div className="mb-4">
            <input
              type="checkbox"
              id="seniorDiscount"
              className="mr-2"
              checked={seniorDiscount}
              onChange={() => setSeniorDiscount(!seniorDiscount)}
              disabled={!isPinValid} // Disable until PIN is verified
            />
            <label htmlFor="seniorDiscount">Senior Citizen Card</label>
          </div>

          {seniorDiscount && (
            <div className="mb-4">
               <label className="mt-4">Number of Senior Citizens:</label>
              <input
                type="number"
                className="border border-gray-300 rounded p-2 mb-4 w-full"
                placeholder="Enter senior pax"
                value={seniorPax}
                onChange={(e) => setSeniorPax(e.target.value)}
              />
              <div className="flex">
                <input
                  type="text"
                  placeholder="ID Number"
                  className="border border-gray-300 rounded p-2 mb-2 w-1/3"
                  value={seniorId}
                  onChange={(e) => setSeniorId(e.target.value)}
                  disabled={!isPinValid} // Disable until PIN is verified
                />
                <input
                  type="text"
                  placeholder="Name"
                  className="border border-gray-300 rounded p-2 mb-2 w-3/4"
                  value={seniorName}
                  onChange={(e) => setSeniorName(e.target.value)}
                  disabled={!isPinValid} // Disable until PIN is verified
                />
              </div>
            </div>
          )}

        <label className='text-xs'>Discount</label>
          <input
            type="text"
            placeholder="Promo Discount"
            className="border border-gray-300 rounded p-2 mb-2 w-full"
            value={promoDiscount.toFixed(2)}
            onChange={(e) => setPromoDiscount(Number(e.target.value))}
            disabled={!isPinValid} // Disable until PIN is verified
          />

          <label className='text-xs'>No. of Pax</label>
          <input
            type="number"
            placeholder="PAX"
            className="border border-gray-300 rounded p-2 mb-2 w-full"
            value={pax}
            onChange={(e) => setPax(Number(e.target.value))}
            disabled={!isPinValid} // Disable until PIN is verified
          />

          <label className='text-xs'>Remarks</label>
          <textarea
            placeholder="Remarks"
            className="border border-gray-300 rounded p-2 mb-4 w-full"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            disabled={!isPinValid} // Disable until PIN is verified
          ></textarea>

          <label className='text-xs'>Amount Paid</label>
          <input
            type="number"
            placeholder="Amount Paid"
            className="border border-gray-300 rounded p-2 mb-4 w-full"
            value={amountPaid}
            onChange={(e) => setAmountPaid(Number(e.target.value))}
            
            disabled={!isPinValid} // Disable until PIN is verified
          />

          <button
            onClick={handleComputeChange}
            className="border-blue-500 text-blue-500 outline font-medium  shadow-md  focus:outline-none focus:ring-2 focus:ring-yellow focus:ring-offset-2 px-4 py-2 rounded w-full mr-5 mt-5"
          >
             Compute Change
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingModal;
